<div
  class="content-card"
  [class.content-card--no-subtitle]="!subtitle()"
  [ngStyle]="{
    'border': borderColor(),
    'background': backgroundColor()
  }">

  <div class="content-card__header">
    <div
      class="content-card__icon-container"
      [ngStyle]="{ 'background-color': iconBackgroundColor() }">
      @if (useIconSlot()) {
        <div class="content-card__icon">
          <ng-content select="[iconSlot]"></ng-content>
        </div>
      } @else if (isIconFile()) {
        <div
          class="content-card__icon content-card__icon--img"
          [ngStyle]="{
            '-webkit-mask-image': 'url(' + icon() + ')',
            'mask-image': 'url(' + icon() + ')',
            'background-color': iconColor()
          }"></div>
      } @else {
        <div
          class="content-card__icon"
          [innerHTML]="getSafeIcon()"
          [ngStyle]="{ '--icon-color': iconColor() }"></div>
      }
    </div>

    <div class="content-card__main">
      <div class="content-card__content">
        <p class="content-card__title">{{ title() }}</p>
        @if (subtitle()) {
          <p class="content-card__subtitle">{{ subtitle() }}</p>
        }
      </div>

      <div class="content-card__right">
        <ng-content select="[rightContent]"></ng-content>
      </div>
    </div>
  </div>

  <div class="content-card__body">
    <ng-content></ng-content>
  </div>
</div>
